import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { ContratarComponent } from 'src/app/app.components/colectivos/contratar/contratar.component';
import { HeaderColectivosComponent } from 'src/app/app.components/colectivos/layout-colectivos/header-colectivos/header-colectivos.component';
import { LayoutColectivosComponent } from 'src/app/app.components/colectivos/layout-colectivos/layout-colectivos.component';
import { MejorPrecioComponent } from 'src/app/app.components/colectivos/mejor-precio/mejor-precio.component';
import { PreguntasColectivoComponent } from 'src/app/app.components/colectivos/preguntas-colectivo/preguntas-colectivo.component';
import { SolicitudEnCursoComponent } from 'src/app/app.components/colectivos/solicitud-en-curso/solicitud-en-curso.component';
import { VerPrecioComponent } from 'src/app/app.components/colectivos/ver-precio/ver-precio.component';
import { SoloNumerosDecimalesDirective } from 'src/app/core.utilidades/directivas/solo-numeros-decimales.directive';
import { SoloNumerosEnterosPositivosDirective } from 'src/app/core.utilidades/directivas/solo-numeros-enteros-positivos.directive';
import { PipeCurrencyEuro } from 'src/app/core.utilidades/pipeEuro';
import { PipeCurrencyEuroSinDecimales } from 'src/app/core.utilidades/pipeEuroSinDecimales';
import { CalcularSeguroComponent } from '../../app.components/colectivos/calcular-seguro/calcular-seguro.component';
import { ModalFechaIdentificacionErroneaComponent } from '../../app.components/modales/modal-fecha-identificacion-no-coincide/modal-fecha-identificacion-erronea.component';
import { ModuloComunModule } from '../modulo-comun.module';
import { ColectivosRoutingModule } from './colectivos-routing.module';
import { CoberturaComponent } from 'src/app/app.components/modales/cobertura/cobertura.component';
import { ModalDireccionEnvioComponent } from 'src/app/app.components/modales/modal-direccion-envio-dialog/modal-direccion-envio.component';
import { ModalPoliticaPrivacidadComponent } from 'src/app/app.components/modales/modal-politica-privacidad/modal-politica-privacidad.component';
import { ModalFallecimientoAccidenteComponent } from 'src/app/app.components/modales/modal-fallecimiento-accidente/modal-fallecimiento-accidente.component';
import { ModalIncapacidadAccidenteComponent } from 'src/app/app.components/modales/modal-incapacidad-accidente/modal-incapacidad-accidente.component';
import { ModalInformacionLegalComponent } from 'src/app/app.components/modales/modal-informacion-legal/modal-informacion-legal.component';
import { ModalPoliticaPrivacidadInformarUsuarioComponent } from 'src/app/app.components/modales/modal-politica-privacidad-informar-usuario/modal-politica-privacidad-informar-usuario.component';
import { ModuloComponentesCompartidosModule } from '../modulo-componentes-compartidos.module';

@NgModule({
    declarations: [

        // layout
        LayoutColectivosComponent,
        HeaderColectivosComponent,

        //componentes
        CalcularSeguroComponent,
        VerPrecioComponent,
        PreguntasColectivoComponent,
        MejorPrecioComponent,
        ContratarComponent,
        SolicitudEnCursoComponent,

        //modales e informacion
        CoberturaComponent,
        ModalDireccionEnvioComponent,
        ModalPoliticaPrivacidadComponent,
        ModalFallecimientoAccidenteComponent,
        ModalIncapacidadAccidenteComponent,
        ModalInformacionLegalComponent,
        ModalPoliticaPrivacidadInformarUsuarioComponent,

        //directivas
        SoloNumerosDecimalesDirective,
        SoloNumerosEnterosPositivosDirective,
        ModalFechaIdentificacionErroneaComponent

    ],
    providers: [

        PipeCurrencyEuro,
        PipeCurrencyEuroSinDecimales

    ],
    imports: [

        ModuloComunModule,
        ModuloComponentesCompartidosModule,

        //routing module
        ColectivosRoutingModule,

    ],
    exports: [

        RouterModule

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ColectivosModule { }
